import { type PaginatedMaintenance, type PaginatedTransformedMaintenance } from "@/api/resources/maintenances/types";
import { isVirtualMaintenance } from "@/api/resources/maintenances/utils";

import type { MaintenanceExtended } from "@waku-care/types/contracts/internal";

// maintenance_items[] is deliberately empty because it was used to compute the progress counters in the old selector
// this is now done in the backend directly but some components still expect the field to exist (just type-wise, no usage)
export const adaptMaintenanceExtended = (maintenance: MaintenanceExtended): PaginatedTransformedMaintenance => ({
  ...maintenance,
  maintenance_items: [],
});

export const getMaintenancePlannedDeviceIds = (maintenance: PaginatedMaintenance): string[] => {
  const planned_devices_maintenance = maintenance.maintenances_to_devices.map((d) => d.device_id);

  const planned_devices_strategy = maintenance.maintenance_strategy
    ? maintenance.maintenance_strategy.maintenance_strategies_to_devices.map((d) => d.device_id)
    : [];

  return isVirtualMaintenance(maintenance) ? planned_devices_strategy : planned_devices_maintenance;
};
